module.exports = {
  Others: 'Другое',
  YouToViewOrFiles: 'У вас нет прав на просмотр или печать файлов, загруженных другими пользователями.',
  BookingAgent: 'Бронирующий агент',
  BasicInformation: 'Основная информация',
  FileHistory: 'История файлов',
  Cancel: 'Отмена',
  Save: 'Сохранить',
  SynchronizeFees: 'Синхронизация расходов',
  ProjectNameCannotBeEmpty: 'Название проекта не может быть пустым!',
  CustomerNameCannotBeEmpty: 'Имя клиента не может быть пустым!',
  ProjectCycleCannotBeEmpty: 'Срок проекта не может быть пустым!',
  EndBeEarlierThanDate: 'Дата окончания не может быть раньше даты начала!',
  AccountingCurrencyCannotBeEmpty: 'Валюта расчёта не может быть пустой!',
  ProjectManagerCannotBeEmpty: 'Менеджер проекта не может быть пустым!',
  ProjectDepartmentCannotBeEmpty: 'Отдел проекта не может быть пустым!',
  ProjectCompanyCannotBeEmpty: 'Компания проекта не может быть пустой!',
  SaveSuccessfully: 'Сохранено успешно',
  TheStatusCannotBeEdited: 'Текущий статус проекта не позволяет редактировать!',
  TheStatusCannotBeDeleted: 'Текущий статус проекта не позволяет удалять',
  PleaseToDeleteTheNumber: 'Подтвердите удаление номера',
  Prompt: 'Подсказка',
  Confirm: 'Подтвердить',
  DeleteSuccessfully: 'Удалено успешно',
  CancelledDeletion: 'Удаление отменено',
  ProjectStatusCompleted: 'Статус проекта: Завершён',
  PleaseCanCloseTheNumber: 'Подтвердите закрытие номера',
  ClosedSuccessfully: 'Закрыто успешно',
  ClosedCancelled: 'Закрытие отменено',
  ProjectStatusInProgress: 'Статус проекта: В процессе',
  PleaseNeedToReopenNumber: 'Подтвердите повторное открытие номера',
  SuccessfullyOpened: 'Открыто успешно',
  CancelledOpening: 'Открытие отменено',
  PleaseSelectARecord: 'Пожалуйста, выберите запись!',
  DeletedSuccessfully: 'Удалено успешно',
  DeletionCancelled: 'Удаление отменено',
  CancelledClosing: 'Закрытие отменено',
  OpenedSuccessfully: 'Открыто успешно',
  XNotAllowViewOrDownload: 'Файл {0} не разрешён для просмотра или скачивания.',
  NoPermissionView: 'У вас нет прав на просмотр или скачивание файла {0}.',
  PleaseToDeleteTheProject: 'Подтвердите удаление проекта с номером {0}.'
}
